/* tslint:disable */
/* eslint-disable */
/**
 * Kiwi Framework
 * Kiwi API description
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MaterialAddResponse
 */
export interface MaterialAddResponse {
    /**
     * 
     * @type {string}
     * @memberof MaterialAddResponse
     */
    classMaterialId: string;
}

/**
 * Check if a given object implements the MaterialAddResponse interface.
 */
export function instanceOfMaterialAddResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "classMaterialId" in value;

    return isInstance;
}

export function MaterialAddResponseFromJSON(json: any): MaterialAddResponse {
    return MaterialAddResponseFromJSONTyped(json, false);
}

export function MaterialAddResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MaterialAddResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'classMaterialId': json['classMaterialId'],
    };
}

export function MaterialAddResponseToJSON(value?: MaterialAddResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'classMaterialId': value.classMaterialId,
    };
}

